<template>
  <div>
    <div v-if="isLoggedIn" class="currency-rate">
      <div class="currency-rate__item hide-tablet">
        <p class="currency-rate__text currency-rate__text_muted">
          {{ $t("national bank rate") }}
        </p>
        <p class="currency-rate__text">{{ date }}</p>
      </div>
      <div class="currency-rate__item">
        <p class="currency-rate__text currency-rate__text_muted">USD</p>
        <p class="currency-rate__text">{{ rate.USD }} ₸</p>
      </div>
      <div class="currency-rate__item">
        <p class="currency-rate__text currency-rate__text_muted">EUR</p>
        <p class="currency-rate__text">{{ rate.EUR }} ₸</p>
      </div>
      <div class="currency-rate__item">
        <p class="currency-rate__text currency-rate__text_muted">RUB</p>
        <p class="currency-rate__text">{{ rate.RUB }} ₸</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";

export default {
  computed: {
    date() {
      return moment().format("DD.MM.YYYY");
    },
    ...mapGetters(["rate", "isLoggedIn"])
  },
  mounted() {
    // console.log(this.rate["KZT"]);
    this.$store.dispatch("fetchCurrencyRate");
  }
};
</script>

<style scoped>
.currency-rate {
  display: flex;
  align-items: center;
}

.currency-rate__item:first-child {
  margin-right: 43px;
}

.currency-rate__item {
  margin-right: 29px;
}

.currency-rate__text {
  margin-top: 3px;
  font-size: 15px;
  color: #ffffff;
}

.currency-rate__text_muted {
  font-size: 13px;
  color: #acb5c5;
}
</style>
